import { Toaster } from "sonner";
import { TooltipProvider } from "./components/ui/tooltip";
import FeedbackInsightsPage from "./pages/Feedback/FeedbackInsightsPage";
import AuthGuard from "./components/AuthGuard";
import "./App.css";

function App(): JSX.Element {
  return (
    <TooltipProvider>
      <AuthGuard>
        <div className="min-h-screen bg-background text-foreground app-gradient">
          <main className="mx-auto flex min-h-screen w-full max-w-5xl flex-col items-start gap-6 px-6 py-10">
            <header className="w-full space-y-4">
              <div className="space-y-2">
                <p className="text-sm font-medium uppercase tracking-widest text-muted-foreground">
                  Feedback Dashboard
                </p>
                <h1 className="text-3xl font-bold">Feedback Insights</h1>
                <p className="max-w-3xl text-muted-foreground">
                  Review and analyse feedback captured through the feedback widget.
                  View submissions, filter by type and rating, and export diagnostic data.
                </p>
              </div>
            </header>

            <section className="w-full rounded-lg border border-border bg-card p-6 shadow-sm">
              <FeedbackInsightsPage />
            </section>
          </main>

          <Toaster position="top-center" richColors closeButton />
        </div>
      </AuthGuard>
    </TooltipProvider>
  );
}

export default App;
